var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.componentKey},[_c('div',{attrs:{"id":"swiper_container"}},[_c('BetMatchDetailsSwiper',{attrs:{"matches":_vm.matches}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }